"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Optionality = void 0;
exports.Optionality = {
    Required: 'required',
    Preferred: 'preferred'
};
